import React from "react";
import "./Toggle.scss";
import { trackFormFieldEntered } from "../../Services/formFieldTracker";

export interface IToggleProps {
    disabled?: boolean //true if toggle is disabled
    isOn: boolean; // true if toggle is on, else false
    children?: string | React.ReactElement; // text/element for label
    id?: string;
    name?: string; // name for input checkbox
    required?: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void; // function to be called on change
    ariaLabel?: string;
}

const Toggle: React.FC<IToggleProps> = (props: IToggleProps) => {
    function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
        trackFormFieldEntered({
            fieldName: props.name || props.id,
            fieldLabel: typeof props.children === "string" ? props.children : props.ariaLabel,
            fieldType: "toggle",
            hasValue: event.target.checked,
        });
        props.onChange(event);
    }

    return (
        <label className="toggle" htmlFor={props.id}>
            {props.children &&
                <span className="tgl_text">{props.children}</span>
            }
            <span className="toggle_outer">
                <input
                    type="checkbox"
                    id={props.id}
                    name={props.name}
                    checked={props.isOn}
                    onChange={handleChange}
                    disabled={props.disabled}
                    required={props.required || undefined}
                    aria-required={props.required ? true : undefined}
                    aria-label={
                      props.children ? undefined : props.ariaLabel || props.name || "Toggle"
                    }
                />
                <span className="toggle_inner" aria-hidden="true"></span>
            </span>
        </label>
    );
};

export default Toggle;
